module.exports = __webpack_public_path__ + "static/img/bg-function-4.1fc0e618.png";